export { default as EditCardDetails } from "./editCardDetails";
